<template>
  <b-row>
    <b-colxx xxs="12" :md="true">
      <h1>{{ title }}</h1>

      <piaf-breadcrumb v-if="breadcrumb" :breadcrumb="breadcrumb" />

      <p class="text-muted custom-text-small translateY-1px d-md-none">{{ description }}</p>
    </b-colxx>

    <b-colxx xxs="auto">
      <div class="top-right-button-container mb-3 mb-md-0">
        <slot name="top-right-button"></slot>
      </div>
    </b-colxx>

    <b-colxx xxs="12">
      <div class="mb-2 mt-2">
        <div class="text-right">
          <b-button
            variant="empty"
            class="pt-0 px-2 d-inline-block d-md-none collapse-toggle-btn"
            v-b-toggle.displayOptions
          >
            <span class="when-open">隱藏</span><span class="when-closed">更多</span>選項
            <span class="icon">
              <i class="simple-icon-arrow-down align-middle" />
            </span>
          </b-button>
        </div>

        <b-collapse id="displayOptions" class="d-md-block">
          <div class="row align-items-center">
            <div class="col">
              <span class="text-muted custom-text-small translateY-1px d-none d-md-inline-block">
                {{ description }}
              </span>
            </div>

            <div class="col-auto">
              <div class="search-sm d-inline-block float-md-left mr-2 align-top">
                <b-input placeholder="搜尋" @input="onSearchInput" />
              </div>

              <span
                class="text-muted text-small mr-2 mb-2"
              >{{ from }}-{{ to }} 共 {{ total }} 筆</span>

              <b-dropdown
                id="ddown2"
                right
                :text="`${perPage}`"
                variant="outline-dark"
                class="d-inline-block"
                size="xs"
              >
                <b-dropdown-item
                  v-for="(size, index) in pageSizes"
                  :key="index"
                  @click="changePageSize(size)"
                  >{{ size }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </b-collapse>
      </div>
      <div class="separator mb-5" />
    </b-colxx>
  </b-row>
</template>

<script>
import { trim } from 'lodash';

export default {
  name: 'DatatableHeading',

  props: [
    'title',
    'description',
    'selectAll',
    'isSelectedAll',
    'isAnyItemSelected',
    'keymap',
    'changePageSize',
    'searchChange',
    'from',
    'to',
    'total',
    'perPage',
    'breadcrumb',
  ],
  data() {
    return {
      collapsed: false,
      categories: [
        {
          label: 'Cakes',
          value: 'Cakes',
        },
        {
          label: 'Cupcakes',
          value: 'Cupcakes',
        },
        {
          label: 'Desserts',
          value: 'Desserts',
        },
      ],
      statuses: [
        {
          text: 'ON HOLD',
          value: 'ON HOLD',
        },
        {
          text: 'PROCESSED',
          value: 'PROCESSED',
        },
      ],
      sortOptions: [
        {
          column: 'title',
          label: 'Product Name',
        },
        {
          column: 'category',
          label: 'Category',
        },
        {
          column: 'status',
          label: 'Status',
        },
      ],
      pageSizes: [5, 10, 20],
    };
  },

  methods: {
    onSearchInput(value) {
      if (this.searchChange) {
        this.searchChange(trim(value));
      }
    },
  },
};
</script>
